import { FC, useEffect, useRef } from 'react';

type Props = {
  url: string;
};

export const LegacySignupFrame: FC<Props> = ({ url }) => {
  const frameRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const legacySignupOrigin = new URL(url).origin;

    const handleMessage = (event: MessageEvent) => {
      const frameWindow = frameRef.current?.contentWindow;

      if (event.source === frameWindow) {
        if (event.origin === legacySignupOrigin && typeof event.data?.url === 'string') {
          window.location.assign(event.data.url);
        }
        return;
      }

      if (event.data?.action === 'back' && event.source !== frameWindow) {
        frameWindow?.postMessage(event.data, legacySignupOrigin);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [url]);

  return (
    <iframe
      ref={frameRef}
      src={url}
      title="Account signup"
      className="fixed inset-0 h-full w-full border-0 bg-white"
      style={{ zIndex: 2147483647 }}
    />
  );
};
